import React from "react";
import "./SaaSUIToolkit.css";

export const SaaSStatCard = ({
  title,
  value,
  icon,
  color = "blue",
  subtitle,
  onClick,
}) => {
  return (
    <div
      className="saas-stat-card"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <div className={`saas-stat-card__icon-wrap saas-stat-card__icon-wrap--${color}`}>
        {icon}
      </div>
      <div className="saas-stat-card__info">
        <div className="saas-stat-card__title">{title}</div>
        <div className="saas-stat-card__value">{value ?? 0}</div>
        {subtitle && <div className="saas-stat-card__trend">{subtitle}</div>}
      </div>
    </div>
  );
};

export default SaaSStatCard;
